/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
enum PackageType {
  PLU4046 = 1,
  PLU4225 = 2,
  PLU4770 = 3,
  SmallBag = 4,
  LargeBag = 5,
  XLargeBag = 6,
}

export default PackageType;
